<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  style="margin: auto; background: transparent; display: block"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 100 100"
  preserveAspectRatio="xMidYMid"
>
  <circle
    cx="50"
    cy="50"
    r="36"
    stroke-width="8"
    [style.stroke]="color"
    stroke-dasharray="56.548667764616276 56.548667764616276"
    fill="none"
    stroke-linecap="round"
  >
    <animateTransform
      attributeName="transform"
      type="rotate"
      repeatCount="indefinite"
      dur="1s"
      keyTimes="0;1"
      values="0 50 50;360 50 50"
    ></animateTransform>
  </circle>
</svg>
